import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import Button, { ButtonVariant } from "components/base/Button";
import ModalEditarConta from "./ModalEditarConta";
import { ContaType } from "services/contaService";

interface BotaoEditarContaProps {
    conta: ContaType;
    size?: "sm" | "lg";
    variant?: ButtonVariant;
    title?: string;
}

const BotaoEditarConta: React.FC<BotaoEditarContaProps> = ({
    conta,
    size = "sm",
    variant = "outline-primary",
    title = "Editar"
}) => {
    const [showModal, setShowModal] = useState(false);

    const handleClick = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    return (
        <>
            <Button
                variant={variant}
                size={size}
                onClick={handleClick}
                title={title}
            >
                <FontAwesomeIcon icon={faEdit} />
            </Button>

            <ModalEditarConta
                show={showModal}
                onHide={handleClose}
                conta={conta}
            />
        </>
    );
};

export default BotaoEditarConta; 